module.exports = __webpack_public_path__ + "static/media/amararaja.5674c63c.svg";